import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import FormCheckbox from "../../components/form/FormCheckbox";
import ModalField from "../../components/modal/ModalField";
import ModalGroup from "../../components/modal/ModalGroup";
import ModalRow from "../../components/modal/ModalRow";

class PreferencesSyncingTab extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <ModalGroup label="Scrivener Syncing">
        <ModalRow>
          <ModalField flex={1}>
            <FormCheckbox
              label="Automatically close and reopen Scrivener projects when required"
              checkboxState={this.props.autoCloseScrivener}
              disabled={false}
              onChange={this.props.onAutoCloseScrivenerChange}
            />
          </ModalField>
        </ModalRow>
      </ModalGroup>
    );
  }
}

PreferencesSyncingTab.propTypes = {
  autoCloseScrivener: PropTypes.bool.isRequired,
  onAutoCloseScrivenerChange: PropTypes.func.isRequired
};

export default PreferencesSyncingTab;
